// Validation functions
export const isPriceOptionDisabled = (value, type, minPrice, maxPrice) => {
  if (!value) return false;

  const numValue = parseInt(value);
  const minPriceNum = parseInt(minPrice) || 0;
  const maxPriceNum = parseInt(maxPrice) || Infinity;

  if (type === 'min') {
    return maxPrice && numValue >= maxPriceNum;
  } else {
    return minPrice && numValue <= minPriceNum;
  }
};

export const isBedroomOptionDisabled = (
  value,
  type,
  minBedrooms,
  maxBedrooms
) => {
  if (!value) return false;

  const numValue = parseInt(value);
  const minBedroomsNum = parseInt(minBedrooms) || 0;
  const maxBedroomsNum = parseInt(maxBedrooms) || Infinity;

  if (type === 'min') {
    return maxBedrooms && numValue >= maxBedroomsNum;
  } else {
    return minBedrooms && numValue <= minBedroomsNum;
  }
};

// Button text generation functions
export const getPriceButtonText = (minPrice, maxPrice) => {
  if (minPrice && maxPrice) {
    const minText = `£${parseInt(minPrice).toLocaleString()}`;
    const maxText = `£${parseInt(maxPrice).toLocaleString()}`;
    return `${minText} - ${maxText}`;
  } else if (minPrice) {
    return `From £${parseInt(minPrice).toLocaleString()}`;
  } else if (maxPrice) {
    return `Up to £${parseInt(maxPrice).toLocaleString()}`;
  }
  return 'Price range';
};

export const getBedroomsButtonText = (minBedrooms, maxBedrooms) => {
  if (minBedrooms && maxBedrooms) {
    return `${minBedrooms} - ${maxBedrooms} bedrooms`;
  } else if (minBedrooms) {
    return `${minBedrooms}+ bedrooms`;
  } else if (maxBedrooms) {
    return `Up to ${maxBedrooms} bedrooms`;
  }
  return 'Bedrooms';
};

export const getHouseTypeButtonText = (selectedHouseTypes) => {
  if (selectedHouseTypes.length === 0) {
    return 'House type';
  } else if (selectedHouseTypes.length === 1) {
    const typeMap = {
      house: 'House',
      flat: 'Flat',
      bungalow: 'Bungalow',
      land: 'Land',
      commercial: 'Commercial',
      other: 'Other',
    };
    return typeMap[selectedHouseTypes[0]] || selectedHouseTypes[0];
  } else {
    return `${selectedHouseTypes.length} types`;
  }
};

export const getAdditionalFiltersButtonText = (
  selectedFeatures,
  selectedBuyingSchemes
) => {
  const totalCount = selectedFeatures.length + selectedBuyingSchemes.length;

  if (totalCount === 0) {
    return 'Filters';
  } else if (totalCount === 1) {
    if (selectedFeatures.length === 1) {
      const featureMap = {
        garden: 'Garden',
        parking: 'Parking',
        'pets-allowed': 'Pets Allowed',
      };
      return featureMap[selectedFeatures[0]] || selectedFeatures[0];
    } else {
      const schemeMap = {
        'new-build': 'New Build',
        'chain-free': 'Chain Free',
      };
      return schemeMap[selectedBuyingSchemes[0]] || selectedBuyingSchemes[0];
    }
  } else {
    return `${totalCount} filters`;
  }
};
